import type { CharacterSummary } from '../types';
import { CharacterCard } from '../components/CharacterCard';

interface Props {
  ownerKey: string;     // raw owner value ("" for legacy)
  ownerLabel: string;   // display label
  chars: CharacterSummary[];
  onOpenCharacter: (key: string) => void;
  onBack: () => void;
}

/**
 * Per-account view: a grid of character cards. The cards are sorted by
 * level descending, then name. Clicking a card jumps into the full
 * armory character display.
 */
export function AccountView({ ownerKey, ownerLabel, chars, onOpenCharacter, onBack }: Props) {
  const sorted = [...chars].sort((a, b) =>
    (b.level - a.level) || a.name.localeCompare(b.name),
  );

  return (
    <div className="account-view">
      <header className="account-view-header">
        <button type="button" className="account-view-back" onClick={onBack} title="Back to dashboard">
          ← Dashboard
        </button>
        <div className="account-view-title-block">
          <h1 className="account-view-title">{ownerLabel}</h1>
          <div className="account-view-sub">
            {chars.length} character{chars.length === 1 ? '' : 's'}
            {ownerKey === '' && (
              <span className="muted">
                {' · '}uploaded with the legacy shared token (no owner attribution)
              </span>
            )}
          </div>
        </div>
      </header>

      {sorted.length === 0 ? (
        <div className="account-view-empty muted">No characters on this account.</div>
      ) : (
        <div className="account-view-grid">
          {sorted.map((c) => (
            <CharacterCard
              key={c.key}
              char={c}
              onClick={() => onOpenCharacter(c.key)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
